import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import { registerTemplateKeys } from '../registerTemplateKeys'
import { RequestTypes } from '../requestTypes'
import { RegisterCsvTemplate } from '@core/entities/register/RegisterCsvTemplate'
import { RequestErrorType } from '@core/utils/api-axios-instance'

export const useDownloadRegisterTemplateCsv = (
  options?: UseMutationOptions<
    RegisterCsvTemplate,
    RequestErrorType,
    RequestTypes['downloadRegisterTemplateCsv']
  >,
) => {
  const queryClient = useQueryClient()
  return useMutation({
    ...registerTemplateKeys.downloadRegisterTemplateCsv,
    retry: 0,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: registerTemplateKeys._def })
    },
    ...options,
  })
}
